module.exports = __webpack_public_path__ + "img/envelope.95af2adf.svg";